module.exports = __webpack_public_path__ + "img/icon-premium-page.00705d97.svg";